import { memo } from "react";
import { DetailPageGoToPreviousPageIcon } from "../../../atoms/Icons";
import { DetailPageTopBarAccentDivider, DetailPageTopBarTitleBlock } from "./TitleBlock";

/**
 * Standard left section for detail top bars: back, accent divider, title + breadcrumb.
 */
const DetailPageTopBarHeader = memo(
  ({ navigateURL = null, step = -1, title, breadcrumbSegments = [], titleAddon = null }) => (
    <>
      <DetailPageGoToPreviousPageIcon navigateURL={navigateURL} step={step} />
      <DetailPageTopBarAccentDivider />
      <DetailPageTopBarTitleBlock
        breadcrumbSegments={breadcrumbSegments}
        title={title}
        titleAddon={titleAddon}
      />
    </>
  ),
);

export { DetailPageTopBarHeader };
